import { PaintTintColorPresets } from './paint-presets.const';
import { ColorUtils } from 'src/app/shared/libraries/colors/colors';

export interface WhiteboardSizePresetModel {
  label: string;
  size: number;
}

export interface WhiteboardColorPresetModel {
  label: string;
  color: string;
}

const brushSizes = [4, 8, 12, 16, 24, 32];
const textSizes = [8, 12, 16, 20, 24, 32];


const makePresets = (sizes) =>
  sizes.slice(0).reverse().map((value) => ({ label: `${value}`, size: value }));

export const WhiteboardBrushSizePresets: WhiteboardSizePresetModel[] = makePresets(brushSizes);
export const WhiteboardTextSizePresets: WhiteboardSizePresetModel[] = makePresets(textSizes);
export const WhiteboardEraserSizePresets: WhiteboardSizePresetModel[] = makePresets(brushSizes);

// Brush Colors: from app paint swatches
export const WhiteboardColorPresets: WhiteboardColorPresetModel[] = [
  ...PaintTintColorPresets.map((preset) => {
    const { label, recipe } = preset;
    const tintColor: [number, number, number] = Array.isArray(recipe.tintColor)
      ? recipe.tintColor
      : [1, 1, 1];

    return {
      label: label,
      color: ColorUtils.rgbToHex(tintColor, true)
    };
  }),
  {
    label: 'White',
    color: '#ffffff'
  },
];

export const DefaultAnnotateBrushSizePreset = WhiteboardBrushSizePresets[4];
export const DefaultAnnotateColorPreset = WhiteboardColorPresets[0];
export const DefaultAnnotateTextSizePreset = WhiteboardTextSizePresets[3];
export const DefaultAnnotateEraserSizePreset = WhiteboardEraserSizePresets[4];
